/** @format */
export function validateComponent(component) {
  return function (props, propName, componentName) {
    // Not a required prop, we can drop early.
    if (!props[propName]) {
      return;
    }

    if (!props[propName].type || props[propName].type !== component) {
      return new Error("Invalid ".concat(propName, " passed to ").concat(componentName, ". Must be ") + '`' + component.name + '`');
    }
  };
}
//# sourceMappingURL=proptype-validator.js.map